import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { APIUserType } from 'api/types';

export type APIClient = {
  id: number;
  fullname: { firstName: string; lastName?: string; patronymic?: string };
  phone: string;
  type: APIUserType;
};

const useClients = () => {
  const { data, error, isLoading, mutate } = useSWR<APIClient[]>('/users/clients', fetcher.swr, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
  });
  return { clients: data ?? [], error, isLoading, mutate };
};

export default useClients;
